export const RUN_STATUS_BAR_WIDTH_CLASSNAME = "w-[8px]";
export const RUN_STATUS_BAR_HEIGHT_CLASSNAME = "h-[30px]";

export const VARIANTS = {
  bar: `${RUN_STATUS_BAR_WIDTH_CLASSNAME} h-[30px]`,
  square: `${RUN_STATUS_BAR_WIDTH_CLASSNAME} h-[8px]`,
} as const;

// intentionally not using "before:border-runStatus-unknown" because it's too light
export const AGGREGATED_STYLE_CLASSES = `
  relative
  before:content-['']
  before:absolute
  before:-z-1
  before:top-[3px]
  before:-left-[3px]
  before:border-grey-800
  before:border-l-2
  before:border-b-2
  before:w-full
  before:h-full
`;
